import React from "react";
import { NavLink } from "react-router";

const SectionNav = ({ data, base, currentUri }) => {

  const sectionNavLinks = [ {name: "Overview", href: `${base}`} ];
  if(data.entry[0].relatedAreasOfExpertise.length > 0 || data.entry[0].relatedAreasOfExpertiseFocusAreas.length > 0) sectionNavLinks.push({name: "Areas of expertise", href: `${base}/areas-of-expertise`});
  if(data.entry[0].relatedFocusArea.length > 0) sectionNavLinks.push({name: "Related focus areas", href: `${base}/focus-areas`});
  if(data.relatedFocusAreaProjects.length > 0 || data.relatedAreaOfExpertiseProjects.length > 0) sectionNavLinks.push({name: "All projects", href: `${base}/projects`});
  if(data.entry[0].relatedTeamMembers.length > 0) sectionNavLinks.push({name: "Team", href: `${base}/team`});

  return (
    <section className="section-nav">
      <div className="shell">
        <nav className="section__nav">
          <ul>
            {sectionNavLinks.map((item, i) => (
              <li key={`section-nav-${i}`} className={item.href === currentUri ? "is-active" : ""}>
                <NavLink to={item.href}>{item.name}</NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default SectionNav;
